@if (toastService.toast(); as toast) {
  <div class="toast-host" aria-live="assertive" aria-atomic="true">
    <section class="toast-message" [class.toast-error]="toast.type === 'error'">
      <svg
        class="toast-icon"
        viewBox="0 0 24 24"
        fill="currentColor"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 2 1 21h22zm1 16h-2v-2h2zm0-4h-2v-4h2z" />
      </svg>
      <p>{{ toast.message }}</p>
      <button type="button" class="toast-close" aria-label="Close" (click)="toastService.clear()">
        <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
          <path d="M18.3 5.71 12 12l6.3 6.29-1.41 1.41L10.59 13.41 4.29 19.7 2.88 18.29 9.17 12 2.88 5.71 4.29 4.3l6.3 6.29 6.3-6.29z" />
        </svg>
      </button>
    </section>
  </div>
}
